<div class="page-container rep-review-container container pb-3">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (repId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  } @else {
    <app-rep-review-detail [repId]="repId" />
  }
</div>
